//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppMain',
  data: function data() {
    return {};
  },
  computed: {
    cachedViews: function cachedViews() {
      console.log(this.$store.state.tagsView.cachedViews, '页面');
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    },
    keepAlive: function keepAlive() {
      return this.$route.meta.keepAlive;
    }
  },
  mounted: function mounted() {
    console.log(this.$route.meta.keepAlive);
  }
};